import React from "react";
import logo from "../../../assets/tallansoft.png";
import "./PoweredBy.scss";

// Firma del proveedor del sistema (tallansoft) — solo en el Admin y su login,
// nunca en la pantalla del comensal: ahí manda la marca del restaurante.
// `light`: texto blanco, para ir sobre un fondo oscuro/de color (login).
export function PoweredBy(props) {
  const { light = false } = props;
  return (
    <div className={`powered-by${light ? " powered-by--light" : ""}`}>
      <img src={logo} alt="tallansoft" />
      <span>
        Desarrollado por <strong>tallansoft</strong>
      </span>
    </div>
  );
}
